import { Component, Input, OnInit } from '@angular/core';
import { placeholder } from 'src/app/models/placeholder';
import { NavController } from '@ionic/angular';
import { HelperService } from 'src/app/services/helper/helper.service';

@Component({
  selector: 'order-item',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.scss'],
})
export class OrderItemComponent implements OnInit {
  @Input() orderDetail: any;
  public imagePlaceholder = placeholder;
  public orderDate: Date;

  constructor(private helperService: HelperService) {}

  ngOnInit() {
    this.orderDate = this.helperService.convertToLocalTimezoneDate(this.orderDetail.createdAt.date);
  }
}
